export const IconName = {
  ADD_CIRCLE: 'add-circle',
  CLOSE: 'close',
  DELETE: 'delete',
  DOTS_VERTICAL: 'dots-vertical',
  CHEVRON_LEFT: 'chevron-left',
  CHEVRON_RIGHT: 'chevron-right',
  PLUS: 'plus',
  MINUS: 'minus',
  EYE: 'eye',
  DOCUMENT_DOWNLOAD: 'document-download',
  FILE_PDF: 'file-pdf',
  FILE_IMAGE: 'file-image',
  FILE_VIDEO: 'file-video',
  FILE_AUDIO: 'file-audio',
  FILE_PRESENTATION: 'file-presentation',
  FILE_DOCUMENT: 'file-document',
  ARROW_LEFT_CIRCLE: 'arrow-left-circle',
  ARROW_RIGHT_CIRCLE: 'arrow-right-circle',
  BRIEFCASE: 'briefcase',
  CARET_DOWN: 'caret-down',
  CHECK: 'check',
  CHEVRON_DOWN: 'chevron-down',
  CHEVRON_UP: 'chevron-up',
  CHEVRON_DOUBLE_DOWN: 'chevron-double-down',
  CHEVRON_DOUBLE_UP: 'chevron-double-up',
  CLOUD: 'cloud',
  COPY: 'copy',
  DASHBOARD: 'dashboard',
  DOCUMENT_COPY: 'document-copy',
  DOWNLOAD: 'download',
  EDIT: 'edit',
  ELEMENT_PLUS: 'element-plus',
  EXPORT: 'export',
  EYE_SLASH: 'eye-slash',
  FILTER: 'filter',
  MENU: 'menu',
  REFRESH: 'refresh',
  SEND: 'send',
  SETTINGS: 'settings',
  LINK: 'link',
  MAIL: 'mail',
  PEOPLE: 'people',
  STAR: 'star',
  PROFILE_ADD: 'profile-add',
  PROFILE_TIMER: 'profile-timer',
  CHECKBOX_OUTLINE: 'checkbox-outline',
  CHECKBOX_CHECKED: 'checkbox-checked',
  CHECKBOX_INDETERMINATE: 'checkbox-indeterminate',
  INFO_CIRCLE: 'info-circle',
  CHECK_CIRCLE: 'check-circle',
  WARNING: 'warning',
  ERROR_CIRCLE: 'error-circle',
} as const;
export type IconName = (typeof IconName)[keyof typeof IconName];

// Sizes replicating the Icon component's Size variant in Figma. The px value
// for each is mapped in icon.vue.
export const IconSize = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
} as const;
export type IconSize = (typeof IconSize)[keyof typeof IconSize];

// Pixel dimensions per size (replicating the Figma Icon Size variant 28/24/20/16/12).
export const iconSizePx: Record<IconSize, number> = {
  [IconSize.XS]: 12,
  [IconSize.SM]: 16,
  [IconSize.MD]: 20,
  [IconSize.LG]: 24,
  [IconSize.XL]: 28,
};
